import { Skeleton } from '@/components/ui/skeleton'

export function FileCardSkeleton() {
  return <Skeleton className="h-48 w-full rounded-2xl bg-white/80" />
}
